import react from 'react'
import Combaintop from '../Components/Combaintop/Top'
import Combainbottom from '../Components/Combainbottom/Combainbottom'
import Order from '../Components/User-Dashboard/Order';
import Breadcrumbs from '../Components/banner/New-banner';

function Vieworder(){
    return(
        <>
        <Combaintop/>
        <Breadcrumbs/>
        <Order/>
        <Combainbottom/>
        </>
    );
}
export default Vieworder;